import { createLogger } from '../loggerFacade';

const logger = createLogger('stopwatch');

export class Stopwatch {
    private value: Maybe<number>;

    public start() {
        if (this.value !== undefined) {
            logger.warn('Stopwatch is already running. Please stop it before starting again.', {
                method: 'start',
            });
            return;
        }

        this.value = Date.now();
    }

    public stop(): Maybe<number> {
        if (!this.value) {
            logger.warn('Stopwatch was not started.', {
                method: 'stop',
            });
            return;
        }

        const time = Date.now() - this.value;
        this.value = undefined;

        return time;
    }
}
